var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.text),expression:"text"}],staticClass:"info-note-tooltip"},[_vm._v("?")])}
var staticRenderFns = []

export { render, staticRenderFns }